import React, { FC } from 'react';
import { SrWidget } from './SrWidget';
import { isMobileChannel } from '../../../common/util';

export interface SrWidgetMatchScoreboardProps extends React.HTMLAttributes<HTMLDivElement> {
    matchId: string;
    sportId: string;
}

export const SrWidgetMatchScoreboard: FC<SrWidgetMatchScoreboardProps> = ({ matchId, sportId, ...props }) => {
    const widgetProps = {
        matchId: matchId,
        disableWidgetHeader: true,
        disableGoalscorers: !isMobileChannel(),
        disableMatchInfo: true,
        smallLayout: 'horizontal'
    };
    return <SrWidget widgetName="match.scoreboard" widgetProps={widgetProps} {...props} />;
};
